import Immutable from 'immutable';
import { handleActions } from 'redux-actions';

const MaintenanceCasesState = Immutable.fromJS({
  mCaseListRequestModel: { 
	  	workingTarget: '',
	  	tabsKey: 0,
	 },

   mCaseListViewModel :[],

   files:{'file':'fileLoaction'},
   
   files2:{'file':'fileLoaction'},

   priceFiles:{'file':'fileLoaction'},

   summaryFiles:{'file':'fileLoaction'},

   cardsFiles:{'file':'fileLoaction'},
   
   serialFiles:{'file':'fileLoaction'},

   alert :{
     style:'',
     message:''
   },

   selectedYear: ''
});

const maintenanceCasesReducer = handleActions({

  RESET_FILE_LINKS: (state, { payload }) => {
    return state.merge({
      files: {},
      files2: {},
      priceFiles: {},
      cardsFiles: {},
      serialFiles: {},
    })
  },

  FIND_ALL_MAINTENANCE_CASES: (state, { payload }) => {
    return state.merge({
      mCaseListViewModel: payload.data
    })
  },
  SET_MAINTENANCE_TARGET_CASE: (state, { payload }) => {

    let request = state.get('mCaseListRequestModel');
    return state.merge({
      mCaseListRequestModel: request.set('workingTarget', payload.value)
    })
  },
  SELECT_MAINTENANCE_CASES_TAB: (state, { payload }) => {
    let request = state.get('mCaseListRequestModel');
    return state.merge({
      mCaseListRequestModel: request.set('tabsKey', payload)
    })
  },

  GENERATE_MAINTENANCE_CHECK_FILE_MAP: (state, { payload }) => {
    let resp = state.get('files');
    resp = resp.set(payload.data.bean.caseKey, payload.data.bean.fileLocation)
    return state.merge({
      files: resp
    })
  },

  GENERATE_MAINTENANCE_CHECK_FILE2_MAP: (state, { payload }) => {
    let resp = state.get('files2');
    resp = resp.set(payload.data.bean.caseKey, payload.data.bean.fileLocation)
    return state.merge({
      files2: resp
    })
  },

  GENERATE_MAINTENANCE_SERIAL_FILE_MAP: (state, { payload }) => {
    let resp = state.get('serialFiles');
    resp = resp.set(payload.data.bean.caseKey, payload.data.bean.fileLocation)
    return state.merge({
      serialFiles: resp
    })
  },

  GENERATE_MAINTENANCE_PRICE_FILE_MAP: (state, { payload }) => {
    let resp = state.get('priceFiles');
    resp = resp.set(payload.data.bean.caseKey, payload.data.bean.fileLocation)
    return state.merge({
      priceFiles: resp
    })
  },

  GENERATE_MAINTENANCE_SUMMARY_FILE_MAP: (state, { payload }) => {
    let resp = state.get('summaryFiles');
    resp = resp.set(payload.data.bean.caseKey, payload.data.bean.fileLocation)
    return state.merge({
      summaryFiles: resp
    })
  },

  RESET_CHECK_FILE_LINK: (state, { payload }) => {
    let resp = state.get('files');
    resp = resp.set(payload, undefined)
    return state.merge({
      files: resp
    })
  },

  GENERATE_MAINTENANCE_CARDS_FILE_MAP: (state, { payload }) => {
    let resp = state.get('cardsFiles');
    resp = resp.set(payload.data.bean.caseKey, payload.data.bean.fileLocation)
    return state.merge({
      cardsFiles: resp
    })
  },

  CHANGE_SELECTED_YEAR: (state, { payload }) => {
    return state.merge({
      selectedYear: payload
    })
  }

}, MaintenanceCasesState);

export default maintenanceCasesReducer;


// WEBPACK FOOTER //
// ./src/reducers/maintenanceCasesReducer.js